import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledInteractiveBanner = styled.section`
    ${theme.viewHeight}
    position: relative;
    overflow: hidden;
    .next-video-container {
        ${theme.viewHeight}
    }
    .main-banner-wrapper-stick {
        ${theme.fullHeightWidth}
    }
    .subDetails {
        ${theme.absoluteFillBottom50}
        margin: 0 auto;
        padding-top: 50px;
        ${devices.sm} {
            padding-top: 35px;
        }

        &:after {
            background: ${theme.colors.subTitleBorder};
            ${theme.absoluteFillTopTop}
            content: "";
            height: 1px;
            width: calc(100% - 30px);
            margin: auto;
        }

        ${devices.mediumMin} {
            bottom: 50px;
        }

        ${devices.mediumMax} {
            bottom: 50px;
        }

        ${devices.sm} {
            bottom: 70px;
        }
    }
    .title-wrapper-middle {
        ${theme.flexCol}
        position: relative;
        overflow: hidden !important;
        margin-bottom: 30px;

        .swiper__title {
            &:last-child {
                margin-left: 18%;
                margin-top: 10px;
            }
        }

        h2 {
            position: relative;
            transition: ${theme.transition};
            margin: 0 !important;

            ${theme.bannerTitle}
            ${devices.md} {
                font-size: 4.25rem !important;
            }
        }

        ${devices.sm} {
            margin-bottom: 0;
            padding-bottom: 200px;
            h2 {
                ${theme.bannerTitleMobile}
            }
            .swiper__title {
                &:last-child {
                    margin-left: 0;
                    margin-top: 10px;
                }
            }
        }
    }
    .middle-description {
        ${theme.relativeHidden}

        p {
            position: relative;
            margin: 0 !important;
            transition: ${theme.transition};
        }
    }
    .slide-inner {
        position: relative;
        ${theme.viewHeight}
        video {
            ${theme.absoluteFill}
            object-fit: cover;
            ${theme.fullHeightWidth}
        }

        .container {
            ${theme.bannerContainer}
            ${devices.sm} {
                justify-content: flex-end;
            }
        }

        .next-video-bg {
            &:after {
                content: '';
                ${theme.absoluteFill}
                z-index: 1;
                background: ${theme.colors.bannerTint};
            }

        }

        .global-image, .next-video-bg, .global-images {
            will-change: clipPath;
            overflow: hidden;
            ${theme.fullHeightWidth}
            margin: 0;

            ${theme.absoluteFill}
            &:after {
                content: '';
                ${theme.absoluteFill}
                z-index: 1;
                background: ${theme.colors.bannerTint};
            }

            video {
                ${theme.absoluteFill}
                object-fit: cover;
            }
        }

        &__info {
            position: relative;
            transition: ${theme.transition};

            .container {
                overflow: visible;
            }

            p {
                color: ${theme.colors.white};
                transition: ${theme.transition};
                transition-delay: 1.2s;
            }

            ${devices.lgMdMin} {
                width: 100%;
            }

            .title {
                transition: ${theme.transition};
                transition-delay: 1.5s;
                transform: none !important;

                &:after {
                    ${theme.displayNone}
                }
            }
            .side-wrapper {
                position: relative;
            }
        }
    }
    ${devices.ResponsiveTabMobile} {
        ${theme.viewHeight}
        .slide-inner {
            ${theme.viewHeight}

        }

    }
    ${devices.sm} {
        ${theme.viewHeight}

        .mobile {
            ${theme.displayBlock}
        }
        .title {
            padding: 0;
            &:before {
                ${theme.displayNone}
            }
        }
        .slide-inner {
            ${theme.viewHeight}
            &__info {
                ${theme.relativeHidden}
            }
        }


    }

`;